module.exports = __webpack_public_path__ + "themes/fq/img/character.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/character.png
// module id = 59
// module chunks = d-game